import { render, staticRenderFns } from "./NewFileDialog.vue?vue&type=template&id=5468c632&scoped=true"
import script from "./NewFileDialog.vue?vue&type=script&lang=js"
export * from "./NewFileDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5468c632",
  null
  
)

export default component.exports